// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WdRd","newExpiryDate":"styles_newExpiryDate__2rcGB","footer":"styles_footer__1pEgZ"};